var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.82 29.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a2f993c7-56c4-42cf-98a7-b660758dcb51{fill:#309ea6;}.bfd7b213-af26-4aeb-95f4-fa116e2f2051{fill:#136168;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e80a6138-9120-44fb-a62f-792b7d42939f",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "af6c0f3b-9db3-4a63-9705-eb92261abed3",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "a2f993c7-56c4-42cf-98a7-b660758dcb51",
    points: "22.38 0 16.78 9.71 27.99 9.71 22.38 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "a2f993c7-56c4-42cf-98a7-b660758dcb51",
    points: "5.61 9.71 0 0 11.21 0 5.61 9.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "bfd7b213-af26-4aeb-95f4-fa116e2f2051",
    points: "33.6 0 27.99 9.71 22.39 19.43 16.78 9.71 11.17 19.43 16.78 29.14 27.07 29.14 27.99 29.14 27.99 29.14 33.6 19.43 39.21 9.71 44.82 0 33.6 0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColored);
export default __webpack_public_path__ + "static/media/logo_colored.1979020d.svg";
export { ForwardRef as ReactComponent };